export enum StorageKey {
  TOKEN = "token",
  PASSPHRASE = "passphrase",
  COLLECTION_DETAILS = "collection_details",
  DELETION_ID = "deletion_id",
}

const PRESERVE_KEYS: Array<StorageKey> = [StorageKey.DELETION_ID];

export class Storage {
  static get(key: StorageKey) {
    // Use sessionStorage for tokens (clears on browser close)
    // Use localStorage only for non-sensitive data that should persist
    if (key === StorageKey.DELETION_ID) {
      return window.localStorage.getItem(key);
    }
    return window.sessionStorage.getItem(key);
  }

  static set(key: StorageKey, value: string) {
    // Don't store passphrases at all - they should never be persisted
    if (key === StorageKey.PASSPHRASE) {
      return; // No-op, don't store passphrase
    }

    // Use sessionStorage for tokens (clears on browser close)
    // Use localStorage only for non-sensitive data that should persist
    if (key === StorageKey.DELETION_ID) {
      window.localStorage.setItem(key, value);
    } else {
      window.sessionStorage.setItem(key, value);
    }
  }

  static remove(key: StorageKey) {
    window.sessionStorage.removeItem(key);
    window.localStorage.removeItem(key);
  }

  static clear() {
    // Clear sessionStorage
    window.sessionStorage.clear();

    // Clear localStorage except preserved keys
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && !PRESERVE_KEYS.includes(key as StorageKey)) {
        window.localStorage.removeItem(key);
      }
    }
  }

  static clearCollectionDetails() {
    window.sessionStorage.removeItem(StorageKey.COLLECTION_DETAILS);
  }
}
